import { type Epic, combineEpics } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { logoutRequest } from '@/api/user';
import { navigate } from '@/slices/app';
import { clearUser, logout } from '../actions';

const logoutEpic: Epic = (action$) =>
  action$.pipe(filter(logout.match), request(logoutRequest, logout));

const logoutSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(logout.succeeded.match),
    mergeMap(() => [clearUser(), navigate({ to: '/auth/login' })]),
  );

export default combineEpics(logoutEpic, logoutSucceededEpic);
